import { FRONTEND_ROUTES } from '../Routes/frontend_routes.js';

/**
 * Titles are stored as [Spanish (0), English (1)]
 */
export const META_MAP = {
  // 1. PUBLIC LANDING PAGES
  [FRONTEND_ROUTES.landing]: {
    titles: ["MedCleir | Historial Médico Digital", "MedCleir | Digital Medical History"],
    description: ["Tu salud en un solo lugar.", "Your health in one place."],
    ogImage: "/images/landing-preview.png"
  },
  [FRONTEND_ROUTES.auth]: {
    titles: ["Iniciar Sesión | MedCleir", "Login | MedCleir"],
    description: ["Accede a tu cuenta de MedCleir.", "Log in to your MedCleir account."],
    noIndex: true
  },
  [FRONTEND_ROUTES.socials]: {
    titles: ["Conecta con Nosotros | MedCleir", "Connect with Us | MedCleir"]
  },
  [FRONTEND_ROUTES.confirm_email]: {
    titles: ["Verificando Correo... | MedCleir", "Verifying Email... | MedCleir"],
    noIndex: true 
  },

  // 2. SUB-PAGES
  [FRONTEND_ROUTES.relative_search]: {
    titles: ["Buscar Profesional | MedCleir", "Find a Professional | MedCleir"]
  },
  [FRONTEND_ROUTES.relative_professionals]: {
    titles: ["Para Profesionales | MedCleir", "For Professionals | MedCleir"]
  },
  [FRONTEND_ROUTES.relative_about]: {
    titles: ["Sobre Nosotros | MedCleir", "About Us | MedCleir"]
  },
  [FRONTEND_ROUTES.relative_patients]: {
    titles: ["Para Pacientes | MedCleir", "For Patients | MedCleir"]
  },

  // 3. REGISTRATION FLOW
  [FRONTEND_ROUTES.register]: {
    titles: ["Únete a MedCleir | Registro de Paciente", "Join MedCleir | Patient Sign Up"]
  },
  [FRONTEND_ROUTES.register_professional]: {
    titles: ["Registro Profesional | MedCleir", "Professional Registration | MedCleir"]
  },
  [FRONTEND_ROUTES.verify]: {
    titles: ["Revisa tu Correo | MedCleir", "Check Your Email | MedCleir"],
    noIndex: true
  },

  // 4. PROTECTED / DASHBOARD
  [FRONTEND_ROUTES.dashboard]: {
    titles: ["Mi Panel | MedCleir", "My Dashboard | MedCleir"],
    noIndex: true
  },

  // 5. STATUS PAGES
  "404": {
    titles: ["Página No Encontrada | MedCleir", "Page Not Found | MedCleir"],
    noIndex: true
  }
};